/**
 * Searchanise: synthesize Escape to close instant search.
 *
 * Non–search templates: click outside first `.snize-search` → ESC.
 *
 * `body.template-search` + `body.snize-search-open`: narrow “inside” = visible search bar
 * wrapper only (no `.snize-search` page wrappers).
 *
 * Debug bar logs: `window.__DEBUG_SNIZE_SEARCH_BAR__ = true` or `localStorage.debugSnizeSearch = '1'`.
 * Live hit-test (stack / pointer-events / z-index): add `?snize_hit_debug=1` to the URL on /search.
 */
(function () {
  'use strict';

  var BODY_OPEN = 'snize-search-open';
  var TEMPLATE_SEARCH = 'template-search';
  var DEFAULT_CONTAINER = '.snize-search';
  var SEARCH_BAR_DEBUG = false;
  var PREFIX = '[SnizeSearchBar]';

  function debugOn() {
    if (SEARCH_BAR_DEBUG) return true;
    try {
      if (window.__DEBUG_SNIZE_SEARCH_BAR__ === true) return true;
      if (localStorage.getItem('debugSnizeSearch') === '1') return true;
    } catch (e) {}
    return false;
  }

  function log() {
    if (!debugOn()) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift(PREFIX);
    console.info.apply(console, a);
  }

  function dispatchEscape() {
    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        keyCode: 27,
        which: 27,
        bubbles: true,
        cancelable: true,
      })
    );
  }

  function isSearchTemplate() {
    return document.body.classList.contains(TEMPLATE_SEARCH);
  }

  function isVisible(el) {
    if (!(el instanceof Element)) return false;
    if (el.closest('[hidden]')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
      return false;
    }
    var r = el.getBoundingClientRect();
    return r.width >= 1 && r.height >= 1;
  }

  function firstVisibleMatch(selector) {
    var list = document.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) {
      if (isVisible(list[i])) return list[i];
    }
    return null;
  }

  /** Nearest theme wrapper around a search input (order: header pill/shell, then page search). */
  function wrapperFromFocusedInput(input) {
    if (!(input instanceof Element)) return null;
    var order = [
      '.header-searchanise__pill',
      '.header-searchanise__shell',
      'search-page-input-component',
      '.search-page-input__parent',
    ];
    for (var i = 0; i < order.length; i++) {
      var w = input.closest(order[i]);
      if (w && isVisible(w)) return w;
    }
    return isVisible(input) ? input : null;
  }

  /**
   * Prefer the wrapper for the focused `q` input (avoids using header pill while typing in page search).
   * Fallback: first visible match in global selector order.
   */
  function findActiveSearchBar() {
    var ae = document.activeElement;
    if (ae && ae.matches && ae.matches('input[name="q"]:not([type="hidden"])')) {
      var fromFocus = wrapperFromFocusedInput(ae);
      if (fromFocus) {
        log('active bar from focused input:', fromFocus);
        return fromFocus;
      }
    }

    var selectors = [
      '.header-searchanise__pill',
      '.header-searchanise__shell',
      '.search-page-input__parent',
      'search-page-input-component',
    ];
    for (var s = 0; s < selectors.length; s++) {
      var el = firstVisibleMatch(selectors[s]);
      if (el) {
        log('active bar from first visible selector:', selectors[s], el);
        return el;
      }
    }
    return firstVisibleMatch('input[name="q"]:not([type="hidden"])');
  }

  function isCloseButtonInBar(target, bar) {
    if (!(target instanceof Element) || !bar.contains(target)) return false;

    if (target.closest('[data-header-searchanise-close], .header-searchanise__close')) {
      return true;
    }
    if (target.closest('.snize-search-close, [class*="snize-search-close"]')) {
      return true;
    }

    var btn = target.closest('button, [role="button"]');
    if (!btn || !bar.contains(btn)) return false;

    var label = (btn.getAttribute('aria-label') || '') + ' ' + (btn.getAttribute('title') || '');
    if (/close|dismiss|exit/i.test(label)) return true;

    return false;
  }

  function onSearchTemplateClickCapture(e) {
    var bar = findActiveSearchBar();
    log('active search bar:', bar);

    if (!bar) {
      log('no visible search bar — no action');
      return;
    }

    var t = e.target;
    if (!(t instanceof Element)) return;

    if (isCloseButtonInBar(t, bar)) {
      log('X / close click (delegated, capture)');
      e.preventDefault();
      dispatchEscape();
      return;
    }

    if (bar.contains(t)) {
      log('click inside bar — ignore');
      return;
    }

    log('outside bar -> ESC');
    dispatchEscape();
  }

  function onDocumentClickCapture(e) {
    if (!document.body.classList.contains(BODY_OPEN)) return;

    var t = e.target;
    if (!(t instanceof Element)) return;

    if (isSearchTemplate()) {
      onSearchTemplateClickCapture(e);
      return;
    }

    var root = document.querySelector(DEFAULT_CONTAINER);
    if (!root) return;
    if (root.contains(t)) return;
    dispatchEscape();
  }

  document.addEventListener('click', onDocumentClickCapture, true);

  /* Live DOM: top elements under cursor when Snize overlay is open (template-search only). */
  try {
    if (/\bsnize_hit_debug=1\b/.test(window.location.search) && isSearchTemplate()) {
      document.addEventListener(
        'pointerdown',
        function (ev) {
          if (!document.body.classList.contains(BODY_OPEN)) return;
          var stack = document.elementsFromPoint(ev.clientX, ev.clientY);
          console.info('[snize_hit_debug] pointerdown @', ev.clientX, ev.clientY, 'stack depth', stack.length);
          for (var i = 0; i < Math.min(stack.length, 18); i++) {
            var n = stack[i];
            var cs = window.getComputedStyle(n);
            console.info(
              '#' + i,
              n.tagName,
              n.id || '(no id)',
              String(n.className || '').slice(0, 100),
              '| pe:',
              cs.pointerEvents,
              '| z:',
              cs.zIndex,
              '| pos:',
              cs.position
            );
          }
        },
        true
      );
      console.info('[snize_hit_debug] enabled: open Snize search, click the X or page; inspect stack above.');
    }
  } catch (err) {}
})();
